export default __webpack_public_path__ + "static/media/get-more-from-the-bible-this-year-riqkc7bg-a6841d3f40168705fd31c6259caf6d92.8046f29d.jpg";